import React from "react";
import {ApiBankInfo, ApiBuildingInfo, ApiDeviceInfo} from "../../views/NewAlternateView/solutrakApiService";

type BankAndDeviceSelectorsProps = {
    selectedBuilding: ApiBuildingInfo | null;
    selectedBank: ApiBankInfo | null;
    selectedDevice: ApiDeviceInfo | null;
    handleBankSelect: (bank: ApiBankInfo) => void;
    handleDeviceSelect: (device: ApiDeviceInfo) => void;
}

type BankSelectorProps = {
    selectedBuilding: ApiBuildingInfo | null;
    selectedBank: ApiBankInfo | null;
    handleBankSelect: (bank: ApiBankInfo) => void;
}

export function BankAndDeviceSelectors({
                                           selectedBuilding,
                                           selectedBank,
                                           selectedDevice,
                                           handleBankSelect,
                                           handleDeviceSelect
                                       }: BankAndDeviceSelectorsProps) {
    if (selectedBuilding) {
        return (
            <div className="p-4 pb-0 space-y-3">
                {/* Bank Selector */}
                <BankSelector
                    selectedBuilding={selectedBuilding}
                    selectedBank={selectedBank}
                    handleBankSelect={handleBankSelect}/>
                {/* Device Selector */}
                {selectedBank && (
                    <div>
                        <span className="text-sm font-medium text-slate-400 mr-2">Select Device:</span>
                        <div className="flex space-x-2 overflow-x-auto py-1">
                            {selectedBank.deviceInfos?.map(device => (
                                <button
                                    key={device.deviceId}
                                    onClick={() => handleDeviceSelect(device)} // Reuses existing handler
                                    className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 ease-in-out whitespace-nowrap 
                                            ${selectedDevice?.deviceId === device.deviceId
                                        ? 'bg-sky-600 text-white shadow-md'
                                        : 'bg-slate-700/50 hover:bg-slate-600/70 text-slate-300'}`}
                                >
                                    {device.deviceName}
                                </button>
                            ))}
                            {(!selectedBank.deviceInfos || selectedBank.deviceInfos.length === 0) && (
                                <span
                                    className="text-sm text-slate-500 italic">No devices available for this bank.</span>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return <></>;
}

export function BankSelector({
                                 selectedBuilding,
                                 selectedBank,
                                 handleBankSelect
                             }: BankSelectorProps) {

    /* Bank Selector */
    return (
        <div>
            <span className="text-sm font-medium text-slate-400 mr-2">Select Bank:</span>
            <div className="flex space-x-2 overflow-x-auto py-1">
                {selectedBuilding.bankInfos?.map(bank => (
                    <button
                        key={bank.bankId}
                        onClick={() => handleBankSelect(bank)} // Reuses existing handler
                        className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 ease-in-out whitespace-nowrap 
                                          ${selectedBank?.bankId === bank.bankId
                            ? 'bg-sky-600 text-white shadow-md'
                            : 'bg-slate-700/50 hover:bg-slate-600/70 text-slate-300'}`}
                    >
                        {bank.bankName}
                    </button>
                ))}
                {(!selectedBuilding.bankInfos || selectedBuilding.bankInfos.length === 0) && (
                    <span className="text-sm text-slate-500 italic">No banks available for this building.</span>
                )}
            </div>
        </div>
    );
}
